/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { AppConfigService } from "../../app-config/app-config.service";
import { catchError, Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  	providedIn: 'root'
})

export class HttpDeleteParticipantService {

    public readonly URL: string;

    constructor(
        private http: HttpClient,
        private configSvc: AppConfigService
    ) {
        this.URL = this.configSvc.settings.nodeUrl + 'participants/';
    }

    public deleteParticipant$(participantID: string): Observable<void> {

        const headers = new HttpHeaders({
            'x-api-key': this.configSvc.settings.participantsAPIKey
        });

        return this.http.delete<void>(`${this.URL}${participantID}`, { headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 204) {
                        return throwError(() => new Error('Eliminado correctamente'));
                    }
                    return throwError(() => new Error(error.error?.message || 'Error al eliminar el participante'));
                })
            );
    }

}